/* Coaster preview (assets/coaster-draw.js) – Leatherius Woodman
 *
 *   CTDraw.render({
 *     coasters: [{ leather: { img, hex }, letter: 'A' }, ...],   // 1 to 8 coasters, each its own leather and initial
 *     frame: 'https://…/coaster-frame.png',                     // the floral die as a mask (white = pressed in)
 *     floralOnly: false,                                         // the frame without an initial
 *     active: 0                                                  // the coaster being edited (ring), or -1
 *   }) -> SVG string
 *   CTDraw.onFontsReady(fn)
 *
 * The floral frame is lifted from the photo of a real stamped coaster, so every leather shows the same die. The initial
 * is pressed in the middle with the coaster letters (stand-in face until the workshop font arrives). Stitching and felt
 * edge are drawn. Sets lie on the table in a loose row, the way the photos show them.
 */
(function (win) {
  // stand-in for the coaster letter die (flared serif capitals); swap the family when the workshop font file comes
  var FAM = "'Trocchi','Rozha One','Playfair Display',Georgia,serif", FACE = "100px 'Trocchi'";
  var UID = 0, PFX = 'ctd' + Math.floor(Math.random() * 1e6).toString(36);

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function r1(v) { return Math.round(v * 10) / 10; }
  function hex2(h) { h = (h || '#8a6a4a').replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16); }); }
  function shade(h, f) { var c = hex2(h).map(function (v) { return Math.round(f < 0 ? v * (1 + f) : v + (255 - v) * f); }); return '#' + c.map(function (v) { return ('0' + Math.max(0, Math.min(255, v)).toString(16)).slice(-2); }).join(''); }
  function lum(h) { var c = hex2(h); return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255; }
  function letterOf(s) { s = String(s || '').replace(/\s+/g, ''); return s ? s.charAt(0).toUpperCase() : ''; }

  // tones of a pressed die on this leather: the recess darkens, the lip catches the light (stronger on dark leather)
  function tones(hex) {
    var L = lum(hex), dark = L < .3;
    return { recess: shade(hex, L > .6 ? -.24 : dark ? -.42 : -.3), lip: shade(hex, dark ? .3 : .22), lipO: dark ? .75 : .6, edge: shade(hex, -.45), stitch: L > .55 ? shade(hex, -.22) : shade(hex, -.38) };
  }

  // one coaster, face 400 x 400, drawn at (x, y) with scale s and rotation a
  function coaster(id, k, c, o, x, y, s, a) {
    var hex = (c.leather && c.leather.hex) || '#8a5a3c', img = c.leather && c.leather.img, T = tones(hex), h = '';
    var L = o.floralOnly ? '' : letterOf(c.letter), ghost = !o.floralOnly && !L;
    if (ghost) L = 'A';
    h += '<g transform="translate(' + r1(x) + ' ' + r1(y) + ') rotate(' + r1(a) + ') scale(' + s + ') translate(-200 -200)">';
    // felt edge under the leather, then the leather face
    h += '<rect x="2" y="5" width="400" height="400" rx="40" fill="#9c9c98" filter="url(#' + id + 'sh)"/>';
    h += '<rect width="400" height="400" rx="40" fill="' + hex + '"/>';
    if (img) h += '<rect width="400" height="400" rx="40" fill="url(#' + id + 't' + k + ')" opacity=".3"/>';
    h += '<rect width="400" height="400" rx="40" fill="url(#' + id + 'g)"/>';
    // the floral die: lip first (offset down), then the recess
    if (o.frame) {
      h += '<rect y="2.2" width="400" height="400" fill="' + T.lip + '" opacity="' + T.lipO + '" mask="url(#' + id + 'm)"/>';
      h += '<rect width="400" height="400" fill="' + T.recess + '" mask="url(#' + id + 'm)"/>';
    }
    if (L) {
      var at = ' x="200" font-family="' + FAM + '" font-size="122" text-anchor="middle" stroke-width="2.4"';
      h += '<g' + (ghost ? ' opacity=".4"' : '') + '><text' + at + ' y="244.2" fill="' + T.lip + '" stroke="' + T.lip + '" opacity="' + T.lipO + '">' + esc(L) + '</text><text' + at + ' y="242" fill="' + T.recess + '" stroke="' + T.recess + '">' + esc(L) + '</text></g>';
    }
    // stitching close to the edge
    h += '<rect x="21" y="21" width="358" height="358" rx="26" fill="none" stroke="' + T.stitch + '" stroke-width="2.6" stroke-dasharray="7 5" stroke-linecap="round" opacity=".9"/>';
    h += '<rect x=".7" y=".7" width="398.6" height="398.6" rx="39.5" fill="none" stroke="' + T.edge + '" stroke-width="1.4" opacity=".7"/>';
    if (o.active === k) h += '<rect x="-12" y="-12" width="424" height="424" rx="50" fill="none" stroke="#1a1a1a" stroke-width="5" stroke-dasharray="14 9"/>';
    return h + '</g>';
  }

  // where each coaster lies: [x, y, scale, rotation] in a 1000 x 560 scene
  var LAY = {
    1: [[500, 280, 1.24, -3]],
    2: [[300, 285, 1.02, -5], [700, 275, 1.02, 4]],
    3: [[205, 290, .84, -5], [500, 268, .84, 2], [795, 292, .84, 6]],
    4: [[365, 150, .62, -4], [635, 145, .62, 3], [365, 415, .62, 3], [635, 412, .62, -3]],
    5: [[180, 150, .58, -4], [500, 140, .58, 2], [820, 152, .58, 5], [340, 415, .58, 3], [660, 410, .58, -4]],
    6: [[180, 150, .58, -4], [500, 140, .58, 2], [820, 152, .58, 5], [180, 415, .58, 3], [500, 410, .58, -2], [820, 418, .58, -5]],
    7: [[135, 150, .5, -4], [378, 142, .5, 2], [622, 150, .5, 5], [865, 145, .5, -3], [256, 412, .5, 3], [500, 408, .5, -2], [744, 414, .5, -5]],
    8: [[135, 150, .5, -4], [378, 142, .5, 2], [622, 150, .5, 5], [865, 145, .5, -3], [135, 412, .5, 3], [378, 408, .5, -2], [622, 414, .5, -5], [865, 406, .5, 4]]
  };

  function render(o) {
    o = o || {};
    var id = PFX + (++UID), cs = (o.coasters || []).slice(0, 8);
    if (!cs.length) cs = [{}];
    var lay = LAY[cs.length] || LAY[1];
    var names = cs.map(function (c) { return o.floralOnly ? 'floral' : (letterOf(c.letter) || 'your initial'); });
    var label = (cs.length > 1 ? 'Set of ' + cs.length + ' leather coasters' : 'Leather coaster') + ' with the floral frame, ' + (o.floralOnly ? 'no initial' : 'initials ' + names.join(', '));
    var h = '<svg xmlns="http://www.w3.org/2000/svg" class="ct-svg" viewBox="0 0 1000 560" role="img" aria-label="' + esc(label) + '"><title>' + esc(label) + '</title><defs>';
    if (o.frame) h += '<mask id="' + id + 'm" maskUnits="userSpaceOnUse" x="0" y="0" width="400" height="400"><image href="' + esc(o.frame) + '" width="400" height="400"/></mask>';
    cs.forEach(function (c, k) {
      if (c.leather && c.leather.img) h += '<pattern id="' + id + 't' + k + '" patternUnits="userSpaceOnUse" width="400" height="400"><image href="' + esc(c.leather.img) + '" width="400" height="400" preserveAspectRatio="xMidYMid slice"/></pattern>';
    });
    h += '<linearGradient id="' + id + 'g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".1"/><stop offset=".55" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".12"/></linearGradient>';
    h += '<filter id="' + id + 'sh" x="-10%" y="-10%" width="125%" height="130%"><feDropShadow dx="0" dy="7" stdDeviation="9" flood-color="#2c2416" flood-opacity=".28"/></filter>';
    h += '</defs>';
    cs.forEach(function (c, k) { var p = lay[k]; h += coaster(id, k, c, o, p[0], p[1], p[2], p[3]); });
    return h + '</svg>';
  }

  var cbs = [], done = false, started = false;
  function onFontsReady(cb) {
    if (typeof cb === 'function') cbs.push(cb);
    if (done) return flush();
    if (!(win.document && document.fonts && document.fonts.load && win.Promise)) { done = true; return flush(); }
    if (started) return; started = true;
    var fin = function () { done = true; flush(); };
    try { document.fonts.load(FACE, 'ABC').then(fin, fin); } catch (e) { fin(); }
  }
  function flush() { var a = cbs; cbs = []; for (var i = 0; i < a.length; i++) { try { a[i](); } catch (e) { } } }
  win.CTDraw = { render: render, onFontsReady: onFontsReady, tones: tones, version: '1.0.0' };
  try { onFontsReady(); } catch (e) { }
})(window);
